<template>
    <div>
        <b-modal id="create-edit-project-location" title="Create/Edit a project location" @close="close" scrollable hide-footer>
            <div class="form-group">
                <label for="jobShow">JOB/SHOW</label>
                <input type="text" class="form-control" id="jobShow" v-model="entityName" readonly />
                <label for="name">LOCATION NAME*</label>
                <input type="text" class="form-control" id="name" v-model="resource.attributes.name" />
                <label for="description">DESCRIPTION</label>
                <input type="text" class="form-control" id="description" v-model="resource.attributes.description" />
                <div id="address_section" @change="addressChange()">
                    <label for="address1">ADDRESS LINE 1</label>
                    <address-auto-complete name="address1" :preSelectedValue="resource.attributes.address1" @select="addressAutoComplete"></address-auto-complete>
                    <div v-show="error_address1">
                        <p style="color:red;">{{ error_address1 }}</p>
                    </div>
                    <label for="address2">ADDRESS LINE 2</label>
                    <input type="text" class="form-control" id="address2" v-model="resource.attributes.address2" />
                    <label for="city">CITY*</label>
                    <input type="text" class="form-control" id="city" v-model="resource.attributes.city" />
                    <div v-show="error_city">
                        <p style="color:red;">{{ error_city }}</p>
                    </div>
                    <label for="state">STATE*</label>
                    <select class="form-control" id="state" v-model="state_id">
                        <option value="">Select One</option>
                        <option v-for="item of states" :value="item.attributes.id" :key="item.attributes.id">
                            {{ item.attributes.name }}
                        </option>
                    </select>
                    <div v-show="error_state">
                        <p style="color:red;">{{ error_state }}</p>
                    </div>
                    <label for="postal">POSTAL*</label>
                    <input type="text" class="form-control" id="postal" v-model="resource.attributes.postal" />
                    <div v-show="error_postal">
                        <p style="color:red;">{{ error_postal }}</p>
                    </div>
                    <label for="country">COUNTRY*</label>
                    <select class="form-control" id="country" v-model="resource.attributes.country_id">
                        <option value="1">United States</option>
                        <option value="2">Canada</option>
                        <option value="3">United Kingdom</option>
                        <option value="999">Other</option>
                    </select>
                </div>
                <label for="phone">PHONE</label>
                <input type="text" class="form-control" id="phone" v-model="resource.attributes.phone" />
                <label for="mwCityOverride">MW CITY OVERRIDE</label>
                <input type="text" class="form-control" id="mwCityOverride" v-model="resource.attributes.minwage_override_city" />
                <label for="mwPostalOverride">MW POSTAL OVERRIDE</label>
                <input type="text" class="form-control" id="mwPostalOverride" v-model="resource.attributes.minwage_override_postal" />
                <label for="status">STATUS</label>
                <input type="text" class="form-control" id="status" v-model="resource.attributes.status" />
                <label for="defaultValue">DEFAULT</label>
                <input type="text" class="form-control" id="defaultValue" v-model="resource.attributes.default" />
                <div v-show="error_generic">
                    <br />
                    <p style="color:red">
                        <b-icon icon="exclamation-triangle-fill" variant="danger"></b-icon>&nbsp;{{ error_generic }}&nbsp;<b-button size="sm" @click="overrideAddress()">Yes, This is correct</b-button>
                    </p>
                </div>
                <div v-show="isAddressUpdated">
                    <br />
                    <p style="color:red">
                        <b-icon icon="exclamation-triangle-fill" variant="danger"></b-icon>&nbsp;Original address has been updated.&nbsp;<b-button size="sm" @click="overrideAddress()"
                            >Override</b-button
                        >
                    </p>
                </div>
                <div class="newUserButtonContainer">
                    <b-button @click="close">Cancel</b-button>
                    <b-button @click="saveResource()">Save</b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<style scoped>
.newUserButtonContainer {
    display: flex;
    justify-content: space-between;
}
</style>

<script>
import Vue from 'vue'
// mixins
import modalMixin from '../../mixins/modal'
import toastMixin from '../../mixins/toast'
import AddressAutoComplete from '../../components/addressAutocomplete.vue'

export default Vue.extend({
    components: {
        AddressAutoComplete,
    },
    mixins: [toastMixin, modalMixin],
    props: {
        resource: {
            required: true,
            type: Object,
        },
        entityId: {
            required: true,
            type: [String, Number],
        },
        entityName: {
            required: true,
            type: String,
        },
        states: {
            required: true,
            type: Array,
        },
    },
    data() {
        return {
            state_id: '',
            error_address1: '',
            error_city: '',
            error_state: '',
            error_postal: '',
            error_generic: '',
            isAddressChanged: false,
            isAddressUpdated: false,
            isAddressOverride: false,
        }
    },
    watch: {
        resource(newValue) {
            this.setInitialValues(newValue)
        },
    },
    methods: {
        setInitialValues(resource) {
            if (resource && resource.attributes.state_id) {
                this.state_id = resource.attributes.state_id
            } else {
                this.state_id = ''
            }
        },
        close() {
            this.isAddressChanged = false
            this.isAddressUpdated = false
            this.isAddressOverride = false
            this.removeErrorMessage()
            this.closeModal('create-edit-project-location')
        },
        // address override
        overrideAddress() {
            this.removeErrorMessage()
            this.isAddressOverride = true
            this.isAddressUpdated = false
        },
        addressChange() {
            // remove existing error message and changed true
            if (!this.isAddressChanged) this.isAddressChanged = true
            this.removeErrorMessage()
        },
        removeErrorMessage() {
            if (this.error_generic) this.error_generic = ''
            if (this.error_address1) this.error_address1 = ''
            if (this.error_city) this.error_city = ''
            if (this.error_state) this.error_state = ''
            if (this.error_postal) this.error_postal = ''
        },
        addressAutoComplete(address) {
            if (typeof address === 'object') {
                let state = this.states.find((element) => element.attributes.code == address.address.prov)
                let stateId
                if (state) stateId = state.attributes.id
                else stateId = 66
                let countryId = address.address.country.toUpperCase() == 'US' ? 1 : 2
                // postGrid issue - because of zip+4 code, when we send date to postGrid, they return "corrected" as a status instead of "verify".
                let removedZip4 = address.address.pc.split('-')
                this.resource.attributes.address1 = address.address.address
                this.resource.attributes.city = address.address.city
                this.state_id = stateId
                this.resource.attributes.country_id = countryId
                this.resource.attributes.postal = removedZip4[0]
            } else {
                this.resource.attributes.address1 = address
            }
        },
        verify(address1, address2, city, state, postal, country) {
            // actual verification function
            return new Promise(function(resolve, reject) {
                if (address1.length === 0) {
                    return
                }

                let address = {
                    line1: address1,
                }

                if (address2) {
                    address.line2 = address2
                }
                if (city) {
                    address.city = city
                }
                if (state) {
                    address.provinceOrState = state
                }
                if (postal) {
                    address.postalOrZip = postal
                }
                if (country) {
                    address.country = country
                }
                var xhr = new XMLHttpRequest()
                xhr.open('POST', 'https://api.postgrid.com/v1/addver/verifications?includeDetails=true')
                xhr.setRequestHeader('Content-Type', 'application/json')
                if (process.env.VUE_APP_POSTGRID_API_KEY) {
                    xhr.setRequestHeader('X-API-KEY', process.env.VUE_APP_POSTGRID_API_KEY)
                }
                xhr.timeout = 15000
                xhr.onload = function() {
                    var resp = JSON.parse(xhr.responseText)
                    if (xhr.status === 200) {
                        resolve(resp.data)
                    } else {
                        reject(resp)
                    }
                }
                // late response
                xhr.ontimeout = function(e) {
                    reject()
                }
                xhr.send(JSON.stringify({ address }))
            })
        },
        async verifyFields(address1, address2, city, state, postal, country) {
            if (!address1) {
                return false
            }
            // we want to separate suite number and key into line 2
            // postgrid provide line 1 with suite number and key
            let line2CustomString = ''

            try {
                if (state) state = this.states.find((element) => element.attributes.id == state).attributes.code
                if (country) country = country == 1 ? 'US' : 'CA'
                let result = await this.verify(address1, address2, city, state, postal, country)
                if (result.line1) address1 = result.line1

                if (result.zipPlus4) {
                    result.postalOrZip = result.postalOrZip ? result.postalOrZip + '-' + result.zipPlus4 : result.zipPlus4
                }
                if (result.urbanization) {
                    result.line2 = result.line2 ? result.line2 + ' URB ' + result.urbanization : result.urbanization
                }
                if (result.line2) address2 = result.line2
                if (result.details.suiteKey && result.details.suiteID) {
                    if (country == 1 || country.toUpperCase() == 'US') {
                        address1 = address1.split(result.details.suiteKey)[0];
                        line2CustomString = result.line2 ? result.line2 + ' ' + result.details.suiteKey + ' ' + result.details.suiteID : result.details.suiteKey + ' ' + result.details.suiteID;
                        address2 = line2CustomString;
                    }
                }
                if (result.city) city = result.city
                if (result.provinceOrState) {
                    state = this.states.find((element) => element.attributes.code == result.provinceOrState.toUpperCase())
                    if (!state) result.status = 'falied'
                    else state = state.id
                }
                if (result.postalOrZip) postal = result.postalOrZip
                if (result.country) {
                    country = result.country.toUpperCase() == 'US' ? 1 : 2
                }

                if (result.status === 'verified' || result.status === 'corrected') {
                    // insert data
                    this.resource.attributes.address1 = address1
                    this.resource.attributes.address2 = address2
                    this.resource.attributes.city = city
                    this.state_id = state
                    this.resource.attributes.country_id = country
                    this.resource.attributes.postal = postal
                    if (result.status === 'corrected') this.isAddressUpdated = true
                    return true
                } else {
                    if (result.errors) {
                        // handle errors
                        if (result.errors.line1) this.error_address1 = result.errors.line1
                        if (result.errors.city) this.error_city = result.errors.city
                        if (result.errors.provinceOrState) this.error_state = result.errors.provinceOrState
                        if (result.errors.postalOrZip) this.error_postal = result.errors.postalOrZip
                        this.error_generic = 'Address may not be valid'
                    }
                    return false
                }
            } catch (err) {
                this.error_generic = 'Address may not be valid'
                return false
            }
        },
        async saveResource() {
            // set all values
            let error = false
            this.resource.attributes.state_id = this.state_id
            if (!this.resource.attributes.name || !this.resource.attributes.city || !this.resource.attributes.state_id || !this.resource.attributes.postal || !this.resource.attributes.country_id) {
                error = true
            }
            if (error) {
                this.createToast('b-toaster-top-center', 'danger', true, 'Error', 'Please add missing required data before submitting.')
            } else {
                let verifyRes = true
                if (process.env.VUE_APP_ADDRESS_VALIDATION === 'true') {
                    if (this.error_generic) verifyRes = false
                    if (this.isAddressUpdated) this.isAddressUpdated = false
                    if (this.isAddressChanged && this.resource.attributes.state_id != 66 && verifyRes && !this.isAddressOverride && this.resource.attributes.address1) {
                        verifyRes = await this.verifyFields(
                            this.resource.attributes.address1,
                            this.resource.attributes.address2,
                            this.resource.attributes.city,
                            this.resource.attributes.state_id,
                            this.resource.attributes.postal,
                            this.resource.attributes.country_id
                        )
                        if (verifyRes) this.isAddressChanged = false
                    }
                }

                if (verifyRes == true) {
                    // do nothing
                } else {
                    this.createToast('b-toaster-top-center', 'danger', true, 'Error', 'Please check address fields before submitting')
                    return false
                }
                try {
                    this.resource.attributes.entity_id = this.entityId
                    const result = await this.resource.save()
                    if (result.response.status === 200 || result.response.status === 201) {
                        if (this.isAddressOverride) this.isAddressOverride = false
                        if (this.isAddressUpdated) {
                            this.createToast('b-toaster-top-center', 'success', true, 'Success', 'The original address has been updated. Please review.')
                        } else {
                            this.createToast('b-toaster-top-center', 'success', true, 'Success', 'Saved successfully.')
                            this.close()
                        }
                    } else {
                        this.createToast('b-toaster-top-center', 'danger', true, 'Error', 'Cannot Save.')
                        return false
                    }
                } catch (error) {
                    this.createToast('b-toaster-top-center', 'danger', true, 'Error', 'Error')
                    throw error
                }
            }
        },
    },
})
</script>
